export const depositLimitButtonPlugin = {
  beforeRender({ header }) {
    header.actions.children.unshift({
      type: '@sitebase/deposit-limit-button',
      children: [],
      data: {
        id: 'pi-header__deposit-limit-button',
      },
    });
  },
};
